<div class="image-wrapper">
    <!-- Top and Bottom Shaded Areas -->
    <div class="top-shade" *ngIf="!isPdfFile()"></div>
    <div class="bottom-shade" *ngIf="!isPdfFile()"></div>

    <div *ngIf="isPdfFile(); else imageViewer" class="pdf-viewer-container">
        <iframe [src]="fileUrl | safeUrl" class="pdf-frame" frameborder="0"></iframe>
    </div>


    <ng-template #imageViewer>
        <div class="image-wrapper">
            <!-- Top and Bottom Shaded Areas -->
            <div class="top-shade"></div>
            <div class="bottom-shade"></div>
            <!-- Image displayed in the modal -->
            <img [src]="fileUrl" class="modal-image" [style.transform]="zoomStyle">

            <!-- Zoom Controls -->
            <div class="zoom-controls">
                <button (click)="zoomIn()" title="Zoom In">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <path fill="white"
                            d="m19.485 20.154l-6.262-6.262q-.75.639-1.725.989t-1.96.35q-2.402 0-4.066-1.663T3.808 9.503T5.47 5.436t4.064-1.667t4.068 1.664T15.268 9.5q0 1.042-.369 2.017t-.97 1.668l6.262 6.261zM9.539 14.23q1.99 0 3.36-1.37t1.37-3.361t-1.37-3.36t-3.36-1.37t-3.361 1.37t-1.37 3.36t1.37 3.36t3.36 1.37m-.5-2.345V10H7.155V9H9.04V7.116h1V9h1.884v1H10.04v1.885z" />
                    </svg>
                </button>
                <button (click)="zoomOut()" title="Zoom Out">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <path fill="white"
                            d="m19.485 20.154l-6.262-6.262q-.75.639-1.725.989t-1.96.35q-2.402 0-4.066-1.663T3.808 9.503T5.47 5.436t4.064-1.667t4.068 1.664T15.268 9.5q0 1.042-.369 2.017t-.97 1.668l6.262 6.261zM9.539 14.23q1.99 0 3.36-1.37t1.37-3.361t-1.37-3.36t-3.36-1.37t-3.361 1.37t-1.37 3.36t1.37 3.36t3.36 1.37M7.27 10V9h4.539v1z" />
                    </svg>
                </button>
            </div>
        </div>
    </ng-template>

    <div class="button-container" *ngIf="!isPdfFile()">
        <div class="button-container">
            <span class="file-name" [title]="fileName">{{ fileName }}</span>
            <a [href]="fileUrl" [attr.download]="fileName" target="_blank" rel="noopener noreferrer"
                class="download-btn" title="Download">
                <!-- SVG icon -->
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32">
                    <path fill="none" stroke="white" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M9 22c-9 1-8-10 0-9C6 2 23 2 22 10c10-3 10 13 1 12m-12 4l5 4l5-4m-5-10v14" />
                </svg>
            </a>
        </div>


        <!-- Zoom Controls -->
        <div class="zoom-controls">
            <button (click)="zoomIn()">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path fill="white"
                        d="m19.485 20.154l-6.262-6.262q-.75.639-1.725.989t-1.96.35q-2.402 0-4.066-1.663T3.808 9.503T5.47 5.436t4.064-1.667t4.068 1.664T15.268 9.5q0 1.042-.369 2.017t-.97 1.668l6.262 6.261zM9.539 14.23q1.99 0 3.36-1.37t1.37-3.361t-1.37-3.36t-3.36-1.37t-3.361 1.37t-1.37 3.36t1.37 3.36t3.36 1.37m-.5-2.345V10H7.155V9H9.04V7.116h1V9h1.884v1H10.04v1.885z" />
                </svg>
            </button>
            <button (click)="zoomOut()">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path fill="white"
                        d="m19.485 20.154l-6.262-6.262q-.75.639-1.725.989t-1.96.35q-2.402 0-4.066-1.663T3.808 9.503T5.47 5.436t4.064-1.667t4.068 1.664T15.268 9.5q0 1.042-.369 2.017t-.97 1.668l6.262 6.261zM9.539 14.23q1.99 0 3.36-1.37t1.37-3.361t-1.37-3.36t-3.36-1.37t-3.361 1.37t-1.37 3.36t1.37 3.36t3.36 1.37M7.27 10V9h4.539v1z" />
                </svg>
            </button>
        </div>
    </div>